import $ from 'jquery/src/jquery'
import { Swiper } from 'swiper'
import {Navigation, EffectFade, Pagination, Autoplay} from "swiper/modules"
Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

export default () => {
    const nodeSelectors = {
        container: '[js-popup-gallery="container"]',
        close: '[js-popup-gallery="close"]',
        open: '[js-popup-gallery="open"]',
        // slider: '[js-popup-gallery="slider"]',
        // prev: '[js-popup-gallery="prev"]',
        // next: '[js-popup-gallery="next"]',
        // pagination: '[js-popup-gallery="pagination"]',

        slider: '[js-popup-gallery="slider"]',
        prev: '[js-popup-gallery="prev"]',
        next: '[js-popup-gallery="next"]',
        pagination: '[js-popup-gallery="pagination"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close()
            }
        })

        $(nodeSelectors.close).on('click', function () {
            close()
        })

        $(nodeSelectors.open).on('click', function () {
            open()

            let target = $(this).data('js-popup-gallery--slide-to')
            slider.slideTo(target, 0)
        })

        let slider = new Swiper(nodeSelectors.slider, {
            slidesPerView: 1,
            spaceBetween: 50,
            loop: false,
            speed: 300,
            navigation: {
                nextEl: nodeSelectors.next,
                prevEl: nodeSelectors.prev,
            }
        })
    }

    function close() {
        $(nodeSelectors.container).fadeOut()
    }

    function open() {
        $(nodeSelectors.container).fadeIn()
    }

    return Object.freeze({
        init,
    })
}